// import { Dropdown } from "@trussworks/react-uswds";
import { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import {
    SearchFilters
  } from "../../types/v1_schemas";
import { getLookupOptions } from "../../types/lookup";

const DivWithLabel = styled.div`
  display: flex;
  margin-left:65px;
  font-family: Comfortaa;
  font-weight: bold;
  font-size:32px;
  letter-spacing:-3%;
`;

const StyledSpan = styled.span`
  color: dark_blue!important;
  `

const DropdownToggle = styled(Dropdown.Toggle as any)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  background-color: white;
  height: 3rem;
  border-width: 1px;
  border-radius: 0.25rem;
  border-color: #565c65;
  width: 350px;
  @media (max-width: 640px) {
    width: 100%;
  }

  &:hover,
  &:focus {
    background-color: white;
    color: #71767a;
    border-color: #565c65;
  }

  &.show {
    color: white !important;
  }
`;

const DropdownMenu = styled(Dropdown.Menu as any)`
  width: 350px;
  @media (max-width: 640px) {
    width: 100%;
  }
`;

const DropdownElement = styled(Dropdown as any)`
`;

const DropdownItem = styled(Dropdown.Item as any)`
`;

const ServiceCategories = getLookupOptions("serviceCategory");

function TypeOfHelpDropDown({
  filters,
  setServiceCategory,
}: {
  filters: SearchFilters;
  setServiceCategory: (serviceCategory: string[]) => void;
}) {
  const { t } = useTranslation();
  const [selected, setSelected] = useState<string>("");

  return (
    <DropdownElement
      id="type-of-help-dropdown"
      defaultValue=""
      aria-label={t("dropdownPrompt")}
    >
 
      <DropdownToggle
        className={!!filters.serviceCategoryIds?.length ? "text-black" : "text-base"}
      >
 
          {selected === ""
          ? t("dropdownPrompt")
          : selected}
      </DropdownToggle>
      <DropdownMenu>
        <div className="padding-2">
          <DropdownItem 
            key="default" 
            defaultValue="" 
            disabled 
            hidden>
            {t("dropdownPrompt")}
          </DropdownItem>
          {ServiceCategories.map((serviceCategory) => (
            <DropdownItem
              key={t("typeOfHelpShortValues" + serviceCategory.translate)}
              className="text-black text-wrap"
              style={{'fontFamily':'Trebuchet MS!important'}}
              defaultValue={t("typeOfHelpShortValues" + serviceCategory.translate)}
              onClick={() => {
                setSelected(t("typeOfHelpShortValues" + serviceCategory.translate));

                // Ignore empty
                if (serviceCategory.id.toString() !== "") {
                  setServiceCategory([serviceCategory.id.toString()]);
                }
              }}
            >
              {`${t("typeOfHelpValues" + serviceCategory.translate)}`}
            </DropdownItem>
          ))}
        </div>
      </DropdownMenu>
    </DropdownElement>
  );
}

export default TypeOfHelpDropDown;
